import { 
  createContext, 
  useContext, 
  useEffect, 
  useState,
} from "react"

const ThemeContext = createContext()

export function ThemeProvider({ children }) {
  // 1. Load theme from localStorage or revert to dark if not found
  const [theme, setTheme] = useState(localStorage?.getItem("theme") === "light" ? "light" : "dark")

  // 2. Whenever theme changes → update HTML class & localStorage
  useEffect(() => {
    const root = document.documentElement;

    if (theme === "dark") {
      root.classList.add("dark")
    } else {
      root.classList.remove("dark")
    }

    localStorage.setItem("theme", theme);
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
